export default "__VITE_ASSET__DXJTTZSO__"